export const getInstrumentsListState = state => state.instrumentsList;
